module.exports = __webpack_public_path__ + "img/Dantam Fashion 03.33b95706.jpg";